import { urlBaseApi } from "./urls";

export const url_get_AllMetrics = `${urlBaseApi}getAllMetric`;
export const url_get_Metric = (id) => `${urlBaseApi}getMetric/${id}`;
export const url_update_Metric = `${urlBaseApi}metricUpdate`;
export const url_active_Metric = `${urlBaseApi}metricActive`;
export const url_desactve_Metric = `${urlBaseApi}metricDsactive`;
export const url_updateTime = `${urlBaseApi}metricUpdateTime`; 

